import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import DOBVerification from "./components/DOBVerification";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/intake/:token" element={<IntakeFlow />} />
          <Route
            path="/"
            element={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  fontFamily: "Arial, sans-serif",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <h1 style={{ color: "#2c5aa0", marginBottom: "2rem" }}>
                  Patient Portal
                </h1>
                <p
                  style={{
                    color: "#666",
                    textAlign: "center",
                    maxWidth: "600px",
                    fontSize: "1.1rem",
                  }}
                >
                  Please use the secure intake link provided to access your
                  forms. All data is protected under HIPAA regulations and
                  industry-standard security measures.
                </p>
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

function IntakeFlow() {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return <div>Invalid token</div>;
  }

  return (
    <div>
      <DOBVerification token={token} />
    </div>
  );
}

export default App;
